import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const HIDDEN_PATHS = ['/', '/login', '/register'];

const BackButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Hide on excluded paths and the entire admin area (sidebar provides navigation)
  if (HIDDEN_PATHS.includes(location.pathname)) return null;
  if (location.pathname.startsWith('/admin')) return null;

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <button
      type="button"
      onClick={goBack}
      aria-label="Retour"
      data-testid="back-button"
      className="group fixed top-20 left-3 z-[55] inline-flex items-center justify-center h-9 w-9 hover:w-[84px] rounded-full bg-white/70 hover:bg-white text-slate-500 hover:text-[#285BBB] shadow-sm hover:shadow-md backdrop-blur-sm border border-slate-200/60 transition-all overflow-hidden"
    >
      <ArrowLeft className="h-4 w-4 flex-shrink-0" />
      <span className="ml-1 text-sm font-medium max-w-0 group-hover:max-w-[60px] opacity-0 group-hover:opacity-100 transition-all whitespace-nowrap">
        Retour
      </span>
    </button>
  );
};

export default BackButton;
